const defaultPropertyConfig = [
  'isMinPrice',
  'isInServiceTime',
  'isSoldOut',
  'hasInventory',
  'isPreferential',
  'inventoryNum',
  'serviceTimeContent',
  'serviceTimeType',
  'serviceTimes',
  'isCombination'
];

const status = {
  success: {
    massage: 'success',
    status: true,
    key: 'success',
  },
  isInServiceTime: {
    massage: '不在营业时间',
    status: false,
    key: 'isInServiceTime',
  },
  isSoldOut: {
    massage: '该餐品已售罄',
    status: false,
    key: 'isSoldOut',
  },
  params: {
    massage: '参数缺少',
    status: false,
    key: 'params',
  },
  combination: {
    massage: '该组合不存在',
    status: false,
    key: 'combination',
  }
};

// 全局公用验证规则
const globalRules = {
  isSoldOut: [
    { type: 'boolean', value: true, message: '该餐品已售罄' }
  ]
};

export {
  defaultPropertyConfig,
  status,
  globalRules
}





// WEBPACK FOOTER //
// ./../../plugins/cart/common.js